(() => {
  if (window.goldProcessingGuardLoaded) return;
  window.goldProcessingGuardLoaded = true;

  function checkAcknowledgment(event, form) {
    if (!form) return;

    const checkbox = Array.from(form.elements).find(
      (element) => element.matches('[data-gold-processing-checkbox]')
    );

    if (!checkbox || checkbox.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    checkbox.setCustomValidity(
      'Please acknowledge the gold gem processing time before checking out.'
    );
    checkbox.focus();
    checkbox.reportValidity();
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[name="checkout"]');

    if (
      button &&
      ['cart', 'CartDrawer-Form'].includes(button.form?.id)
    ) {
      checkAcknowledgment(event, button.form);
    }
  }, true);

  document.addEventListener('submit', (event) => {
    if (
      ['cart', 'CartDrawer-Form'].includes(event.target.id) &&
      event.submitter?.name === 'checkout'
    ) {
      checkAcknowledgment(event, event.target);
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-gold-processing-checkbox]')) {
      event.target.setCustomValidity('');
    }
  });
})();